module.exports = __webpack_public_path__ + "static/media/background_element.4937b799.png";